import {
    ChangeEvent, useCallback, useEffect, useRef, useState,
} from 'react';
import { CheckboxToggle, InternalTooltip, useDefaultTooltipConnector } from 'react-rainbow-components';
import SaraAvatar from 'components/icons/saraAvatar';
import { Container, IconWrapper, TooltipContent } from './styled';

interface AIStatusProps {
    isActive?: boolean;
    onChange?: (value: boolean) => Promise<boolean>;
}

const AIStatus = ({ isActive = false, onChange }: AIStatusProps) => {
    const [checked, setChecked] = useState(isActive);
    const containerRef = useRef<HTMLDivElement>(null);
    const tooltipRef = useRef();

    const {
        onMouseEnter,
        onMouseLeave,
        isVisible,
    } = useDefaultTooltipConnector({
        tooltipRef,
        triggerRef: () => containerRef as any,
    });

    const tooltipText = checked ? 'Sara is actively responding to messages' : 'Sara is currently not responding to messages';

    const handleOnChange = useCallback(async (event: ChangeEvent<HTMLInputElement>) => {
        setChecked(event.target.checked);
        const result = await onChange?.(event.target.checked);
        if (!result) {
            setChecked(isActive);
        }
    }, [onChange, isActive]);

    useEffect(() => {
        setChecked(isActive);
    }, [isActive]);

    return (
        <>
            <Container
                ref={containerRef}
                onMouseEnter={onMouseEnter}
                onMouseLeave={onMouseLeave}
            >
                <IconWrapper isActive={checked}>
                    <SaraAvatar />
                </IconWrapper>
                <CheckboxToggle
                    value={checked}
                    onChange={handleOnChange}
                />
            </Container>
            <InternalTooltip
                triggerElementRef={() => containerRef}
                isVisible={isVisible}
                preferredPosition="bottom"
                ref={tooltipRef}
            >
                <TooltipContent>
                    {tooltipText}
                </TooltipContent>
            </InternalTooltip>
        </>
    );
};

export default AIStatus;
